import { create } from 'zustand';

const initialState = {
  realPlayTranscription: [],
  token: null,
  tempTitle: '',
};

export const usePublicRealplayStore = create((set, get) => ({
  ...initialState,
  setRealPlayTranscription: (realPlayTranscription = []) => set(() => ({ realPlayTranscription })),
  setToken: (value) => set({ token: value }),
  setTempTitle: (value) => set({ tempTitle: value }),
  closeModal: () =>
    set({
      token: null,
      tempTitle: '',
    }),
  reset: () => {
    set(initialState);
  },
}));
